import axios from "axios";

// Production uses the API on the current domain, including tenant subdomains.
const BACKEND_URL = process.env.NODE_ENV === "production" ? "" : (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

const TENANT_DOMAIN = "cekwifi.site";
export function currentSubdomain() {
  const host = window.location.hostname.toLowerCase();
  if (host.endsWith(`.${TENANT_DOMAIN}`)) {
    const sub = host.slice(0, -(TENANT_DOMAIN.length + 1));
    if (sub !== "www" && /^[a-z0-9][a-z0-9-]*$/.test(sub)) return sub;
  }
  const m = window.location.pathname.match(/^\/t\/([^/]+)/);
  return m ? decodeURIComponent(m[1]) : null;
}

export function tenantUrl(subdomain) {
  return !subdomain || subdomain === "default"
    ? `https://${TENANT_DOMAIN}`
    : `https://${subdomain}.${TENANT_DOMAIN}`;
}

export function tenantParams(extra = {}) {
  const sub = currentSubdomain();
  return sub ? { subdomain: sub, ...extra } : extra;
}

export function formatApiError(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
